module.exports = __webpack_public_path__ + "img/pt-root-04.96fe26b5.svg";